import { ButtonPrimary, ButtonStatus, ButtonTertiary } from "@nova/component-btn"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import classNames from "classnames"
import { ConfirmationModalProps } from "features/modals/WorkspaceConfirmationModalV2"
import { HTMLAttributes } from "react"

export type BeforeYouSyncModalProps = ConfirmationModalProps & HTMLAttributes<HTMLDivElement>

export const BeforeYouSyncModal = ({
    confirm,
    cancel,
    isPerformingAsyncConfirmCallback,
    isPerformingAsyncCancelCallback: __,
    ...rest
}: BeforeYouSyncModalProps) => {
    return (
        <HighPriorityNovaModalContainer
            {...rest}
            title="Before you Sync"
            closeModal={!isPerformingAsyncConfirmCallback ? cancel : undefined}
            className={classNames("w-[28rem]", rest.className)}
            bottomBar={
                <div className="flex ml-auto gap-2">
                    {!isPerformingAsyncConfirmCallback && (
                        <ButtonTertiary title="Cancel" className="ml-auto" onClick={cancel} />
                    )}
                    <ButtonPrimary
                        title="Start Sync"
                        onClick={confirm}
                        status={
                            isPerformingAsyncConfirmCallback
                                ? ButtonStatus.Loading
                                : ButtonStatus.Normal
                        }
                    />
                </div>
            }
        >
            {rest.children}
        </HighPriorityNovaModalContainer>
    )
}
